import React from "react";
import { Box } from "@mui/material";

type Props = {
  children: React.ReactNode;
  label: string;
};

export const mobileDealFieldStyles = {
  display: "grid",
  gridTemplateColumns: "6rem minmax(0, 1fr)",
  rowGap: 0.25,
};

export const mobileDealCardStyles = {
  display: "grid",
  gap: 1,
  border: 1,
  borderColor: "divider",
  borderRadius: 1,
  boxShadow: 1,
  bgcolor: "background.paper",
  px: 1.5,
  py: 1.25,
};

export const mobileDealHeaderStyles = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 1,
};

export const mobileDealIdStyles = {
  color: "primary.main",
  fontWeight: "bold",
  fontSize: "1rem",
};

export const mobileDealDateGroupStyles = {
  display: "flex",
  gap: 1.5,
  textAlign: "right",
};

export const mobileDealDateLabelStyles = {
  color: "text.secondary",
  fontSize: "0.75rem",
  textAlign: "right",
};

export const mobileDealDateValueStyles = {
  color: "text.primary",
  fontSize: "0.875rem",
};

export const mobileDealListStyles = {
  "& .MuiListItemButton-root": {
    alignItems: "flex-start",
    px: 1.5,
    py: 0.75,
  },
  "& .MuiListItemText-root": {
    my: 0,
    width: "100%",
  },
  "& .MuiListItemText-primary": {
    my: 0,
    display: "block",
  },
};

export const MobileDealCardField = ({ children, label }: Props) => (
  <>
    <Box component="span" sx={{ color: "text.secondary" }}>
      {label}
    </Box>
    <Box component="span">{children}</Box>
  </>
);
